import axiosFetch from './config';

export const getReferalActivitie = async()=>{

    let token = await localStorage.getItem('token');
    //console.log(token)
    return await axiosFetch({
      method:'GET',
      url: `/activities?typeOfActivityId=REFERRAL`,
      headers: {
        Authorization: 'Bearer ' + token,
      }
    })
}